import { AnyUser } from "@megaron/access-control";
import { DateString, dateStringSerializer } from "@megaron/date-string";
import { HttpAction, HttpService } from "@megaron/http-service";
import { HandlerMap } from "@megaron/http-service-host";
import { Serializers } from "@megaron/serializers";

import { accountActions } from "./account";
import { accountHistoryQuery } from "./accountHistoryQuery";
import { affiliateCodeActions } from "./affiliateCode";
import { biActions } from "./bi";
import { dailyCodeActivity } from "./codeActivity";
import { codeGroupsActions } from "./codeGroups";
import { productCodeSummary } from "./codeSummary";
import { giftPointActions } from "./giftPoints";
import { importTestCodes } from "./importTestCodes";
import { listingActions } from "./listing";
import { myProductConsumption } from "./myProductConsumption";
import { myPurchaseSummaryQuery } from "./myPurchaseSummaryQuery";
import { productCodeActions } from "./productCode";
import { publicProfileActions } from "./publicProfile";
import { rewardActions } from "./rewards";
import { userActivityDayDtoSerializer } from "./userActivityDayDto";

const dailyUserActivity = HttpAction({
  path: "/userActivity/daily",
  qsSerializer: Serializers.object<{
    groupNames?: string[];
    since?: DateString;
    until?: DateString;
  }>({
    groupNames: Serializers.jsonString(Serializers.array(Serializers.string)).optional(),
    since: dateStringSerializer.optional(),
    until: dateStringSerializer.optional(),
  }),
  method: "get",
  requiresAuth: true as const,
  valueSerializer: Serializers.array(userActivityDayDtoSerializer),
});

export const pointsHttpService = HttpService({
  accountHistoryQuery,

  dailyUserActivity,
  myProductConsumption,
  myPurchaseSummaryQuery,
  importTestCodes,
  dailyCodeActivity,
  productCodeSummary,
  ...giftPointActions,
  ...accountActions,
  ...rewardActions,
  ...productCodeActions,
  ...publicProfileActions,
  ...affiliateCodeActions,
  ...listingActions,
  ...biActions,
  ...codeGroupsActions,
});

export type PointsHandlers = HandlerMap<typeof pointsHttpService, AnyUser>;
